import React from 'react';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import FeedbackTemplateModal from './FeedbackTemplateModal';
import { UserType } from './utils';

const templates = [
  {
    title: 'Too vague',
    text:
      'This description could be stronger by being more descriptive of the goals of the program and those who benefit.',
  },
  {
    title: 'Doesn’t fit program',
    text: 'This description doesn\'t fit the program.',
  },
  {
    title: 'Needs more explanation',
    text: 'This description needs more explanation.',
  },
];

const StyledTemplateDiv = styled.div`
  padding: ${SPACERS.small};
`;

const TemplateTooltip: React.FC<{ title: string; text: string }> = ({
  title,
  text,
}) => {
  return (
    <StyledTemplateDiv>
      <TrueImpactText variant="body-bold">{title}</TrueImpactText>
      <TrueImpactText variant="body">{text}</TrueImpactText>
    </StyledTemplateDiv>
  );
};

interface FeedbackTemplatesProps {
  userType: UserType;
  handleChange: (text: string) => unknown;
}

const StyledDiv = styled.div`
  .template-buttons {
    display: flex;
    justify-content: space-between;
    div:nth-child(2) {
      margin-left: ${SPACERS.extraTiny};
      margin-right: ${SPACERS.extraTiny};
    }
    .template-button {
      height: 100%;
      &:hover {
        color: ${COLORS.whiteBase};
        background-color: ${COLORS.ctaPrimary};
      }
    }
  }
`;

const FeedbackTemplates: React.FC<FeedbackTemplatesProps> = ({
  userType,
  handleChange,
}) => {
  if (userType !== 'ti staff') return null;

  return (
    <StyledDiv>
      <TrueImpactText variant="heading-label">Frequently Used</TrueImpactText>
      <div className="template-buttons">
        {templates.slice(0, 3).map(t => (
          <Tooltip key={t.title} arrow title={<TemplateTooltip {...t} />}>
            {/* div is required for mui tooltip */}
            <div>
              <TrueImpactButton
                variant="secondary-large"
                onClick={() => handleChange(t.text)}
                className="template-button"
              >
                {t.title}
              </TrueImpactButton>
            </div>
          </Tooltip>
        ))}
      </div>
      <FeedbackTemplateModal handleTextChange={handleChange} />
    </StyledDiv>
  );
};

export default FeedbackTemplates;
